
/**
 * Charts API
 */
export default class Charts {
  constructor(axios) {
    this.$axios = axios
  }

  AllListings(period = 'day') {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/charts/listings',
        params: {
          period
        }
      })
        .then(({ data }) => {
          resolve(data.chart)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  AllKijijiListings() {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: '/charts/listings/kijiji'
      })
        .then(({ data }) => {
          resolve(data.kijiji)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }

  SingleListing(id, period = 'day') {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'get',
        url: `/charts/listings/${id}`,
        params: {
          period
        }
      })
        .then(({ data }) => {
          resolve(data.chart)
        })
        .catch((err) => {
          if(err && err.response && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }
}
